module.exports = __webpack_public_path__ + "static/media/icon_menu_active.70edbc3d.svg";